var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73877 5.62634H27.2612C27.7386 5.62634 28.1473 5.79541 28.5093 6.15759C28.8715 6.51959 29.0405 6.92829 29.0405 7.40564V24.5951C29.0405 25.0696 28.8713 25.4757 28.5093 25.8363C28.1474 26.1971 27.7391 26.3666 27.2612 26.3666H4.73877C4.32308 26.3666 3.95997 26.2371 3.63428 25.9633L3.49658 25.8373C3.13594 25.4768 2.96729 25.0702 2.96729 24.5951V7.40564L2.9751 7.22888C3.01244 6.82596 3.18122 6.47402 3.49658 6.15759H3.49756C3.85816 5.79556 4.26423 5.62634 4.73877 5.62634ZM4.23877 7.5658V25.0951H27.7612V8.49451L26.9868 9.00427L16.3657 15.9965C16.2804 16.0413 16.2047 16.0773 16.1372 16.1039C16.116 16.1122 16.0731 16.1234 15.9995 16.1234C15.9262 16.1234 15.884 16.1122 15.8628 16.1039C15.7951 16.0773 15.719 16.0415 15.6333 15.9965L5.23877 9.15271V8.22107L15.7261 15.0902L15.9995 15.2699L16.2729 15.0902L27.4019 7.82361L28.8081 6.90564H3.229L4.23877 7.5658Z",
    fill: "#1390E6",
    stroke: "#1390E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ead4c35c7bfa16abf12716df5b2e808c.svg";
export { ForwardRef as ReactComponent };